import axios from 'axios';
import React, {PureComponent} from 'react';
import Dropzone from 'react-dropzone';
import ReactIntlTelInput from 'react-intl-tel-input-v2';

import {Button, Callout, Intent, MenuItem, ProgressBar} from '@blueprintjs/core';
// import ReactS3Uploader from 'react-s3-uploader';
import countries from '../../common/countries';
import {Select} from '@blueprintjs/select';

import toastr from 'toastr';

// import Vapor from 'laravel-vapor';

import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';

import InputRegular from '../../common/InputRegular';
import FileUpload from '../FileUpload';

export default class AccountVerificationDetails extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedType: 'Registered business',
            fieldsCheckActive: false,
            errorsList: [],
            filteredCountries: countries,
            countryName: 'Select Country',
            fileLoaderActive: false,
            termsChecked: false,
            loaded: 0
        };
    }

    updateErrorsList = async (error, id) => {
        let errorsList = await this.state.errorsList;
        errorsList[parseInt(id) - 1] = await error;
        await this.setState({errorsList})
        // console.log('errorsList: ', errorsList)
    }

    getFullPhoneNumber = (phoneObject) => {
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')) {
            phone = phone.substring(2);
            phone = '+' + phone;
            return phone
        } else if (phone.startsWith('0')) {
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            return phone
        } else if (phone.startsWith('+')) {
            return phone
        } else if (phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            return phone
        } else {
            return ''
        }
    }

    isPhoneNumber = (phone) => {
        // let phone = this.state.phone.phone;
        var regEx = /^[+-]?\d+$/;
        if (regEx.test(phone) && phone.length > 6) {
            return true
        } else {
            return false
        }
    }

    handleSubmit = async () => {
        await this.setState({fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = await false
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            // console.log('errorsList: ',anyErrorActive, this.state.errorsList)
            // if(!anyErrorActive && ((window.location.pathname === '/account-verification/personal-details') &&
            //         this.props.personalDetails && this.props.personalDetails.files.length &&
            //         (this.props.personalDetails.country !== 'Select Country')) ||
            //     ((window.location.pathname === '/account-verification/business-details') &&
            //         this.props.businessDetails && this.props.businessDetails.files.length &&
            //         (this.props.businessDetails.country !== 'Select Country')) ||
            //     ((window.location.pathname === '/account-verification/client-business-details') &&
            //         (this.props.clientBusinessDetails.country !== 'Select Country'))
            // ){
            // console.log('daj podatke: ', window.location.pathname, !anyErrorActive)
            if ((window.location.pathname === '/account-verification/personal-details') &&
                !anyErrorActive && this.isPhoneNumber(this.props.personalDetails.formatedPhone) &&
                this.props.personalDetails.files && this.props.personalDetails.files.length) {

                await this.props.handleSubmitPersonalDetails();
                await this.setState({
                    fieldsCheckActive: false,
                })
            } else if ((window.location.pathname === '/account-verification/business-details') && !anyErrorActive &&
                this.props.businessDetails.files && this.props.businessDetails.files.length
            ) {
                await this.props.handleSubmitBusinessDetails(false);
                await this.setState({
                    fieldsCheckActive: false,
                })
            } else if (!anyErrorActive && (window.location.pathname === '/account-verification/client-business-details')) {
                await this.props.handleSubmitBusinessDetails(false);
                await this.setState({
                    fieldsCheckActive: false,
                })
            }
        }, 300)
    }

    onFileUploadStart = () => {
        this.setState({fileLoaderActive: true});
    }

    onFileUploadEnd = (url, file) => {
        // console.log('onFileUploadEnd: ', url, file)
        window.location.pathname === '/account-verification/personal-details' ?
            this.props.handleUpdateProperty('personalDetails', 'files', [...this.props.personalDetails.files, {
                name: file.name,
                type: file.type,
                url: url
            }])
            :
            window.location.pathname === '/account-verification/business-details' ?
                this.props.handleUpdateProperty('businessDetails', 'files', [...this.props.businessDetails.files, {
                    name: file.name,
                    type: file.type,
                    url: url
                }])
                : this.props.handleUpdateProperty('clientBusinessDetails', 'files', [...this.props.clientBusinessDetails.files, {
                    name: file.name,
                    type: file.type,
                    url: url
                }])
        this.setState({fileLoaderActive: false, loaded: 0});
    }

    onUploadProgressChange = (progress) => {
        this.setState({loaded: Math.round(progress * 100)});
        // console.log('onUploadProgressChange: ', progress, this.state.loaded)
    }


    handleDeleteUrl = (index) => {
        let array = window.location.pathname === '/account-verification/personal-details' ? this.props.personalDetails.files : this.props.businessDetails.files
        let removed = array.splice(index, 1)
        window.location.pathname === '/account-verification/personal-details' ?
            this.props.handleUpdateProperty('personalDetails', 'files', array)
            :
            this.props.handleUpdateProperty('businessDetails', 'files', array)
    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
            .split(/\s+/g)
            .map(s => s.trim())
            .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
                .map((word, i) => {
                    if (i + 1 === words.length && !hasTrailingSpace) {
                        // The last word - ok with the word being "startswith"-like
                        return `(?=.*\\b${escapeRegExp(word)})`;
                    } else {
                        // Not the last word - expect the whole word exactly
                        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                    }
                })
                .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredCountries: filteredArray
        })
    };

    handleUpdatePhone = async (e) => {
        await this.props.handleUpdateProperty(window.location.pathname === '/account-verification/personal-details' ?
            'personalDetails' : window.location.pathname === '/account-verification/business-details' ? 'businessDetails' :
                'clientBusinessDetails', 'phone', e);
        await this.props.handleUpdateProperty(window.location.pathname === '/account-verification/personal-details' ?
            'personalDetails' : window.location.pathname === '/account-verification/business-details' ? 'businessDetails' :
                'clientBusinessDetails', 'formatedPhone', this.getFullPhoneNumber(e));
        // console.log('formatedPhone: ', this.getFullPhoneNumber(e), this.props.personalDetails.formatedPhone)
    }

    componentDidMount() {
    }

    render() {
        const inputProps = {
            placeholder: window.location.pathname === '/account-verification/personal-details' ?
                '+' + this.props.personalDetails.phone.dialCode + ' *********'
                :
                window.location.pathname === '/account-verification/authorized-representative-details' ?
                    '+' + this.props.authorizedRepresentative.phone.dialCode + ' *********'
                    :
                    '+' + this.props.clientContactPersonDetails.phone.dialCode + ' *********',
            disabled: this.props.stepVerified
        };

        const intlTelOpts = {
            preferredCountries: [],
        };

        return (
            <div>
                {
                    window.location.pathname === '/account-verification/business-details' ?
                        <div className='progress-bar-container'>
                            <p style={{position: 'absolute', left: '27%', top: 0, transition: '0.2s'}}>25%</p>
                            <ProgressBar intent='primary' value={0.25} animate={false} stripes={false}/>
                        </div>
                        :
                        window.location.pathname === '/account-verification/personal-details' ?
                            <div className='progress-bar-container'>
                                <p style={{position: 'absolute', left: '48%', top: 0, transition: '0.2s'}}>50%</p>
                                <ProgressBar intent='primary' value={0.5} animate={false} stripes={false}/>
                            </div>
                            :
                            window.location.pathname === '/account-verification/client-business-details' ?
                                <div className='progress-bar-container'>
                                    <p style={{position: 'absolute', left: '66%', top: 0, transition: '0.2s'}}>70%</p>
                                    <ProgressBar intent='primary' value={0.7} animate={false} stripes={false}/>
                                </div>
                                :
                                ''
                }
                {
                    window.location.pathname === '/account-verification/business-details' ?
                        <h1>Business Details</h1>
                        :
                        window.location.pathname === '/account-verification/personal-details' ?
                            <h1>Personal Details</h1>
                            :
                            window.location.pathname === '/account-verification/client-business-details' ?
                                <h1>Client Business Details</h1>
                                :
                                ''
                }
                {this.props.verificationRejected ?
                    this.props.stepVerified ?
                        (window.location.pathname === '/account-verification/client-business-details') ?
                            <Callout icon='tick' intent={Intent.SUCCESS}>This section was successfully
                                verified!</Callout>
                            :
                            this.props.documentationVerified ?
                                <Callout icon='tick' intent={Intent.SUCCESS}>This section was successfully
                                    verified!</Callout>
                                :
                                <Callout intent={'danger'} icon={'warning-sign'}>You need to re-submit this
                                    section!</Callout>
                        :
                        <Callout intent={'danger'} icon={'warning-sign'}>You need to re-submit this section!</Callout>
                    :
                    ''
                }
                {/*<Callout icon='tick' intent={ Intent.SUCCESS }>This section was successfully verified!</Callout>*/}
                {/*<Callout intent={'danger'} icon={'warning-sign'}>You need to re-submit this section!</Callout>*/}
                {
                    window.location.pathname === '/account-verification/personal-details' ?
                        <div className='inputs-container'>
                            <InputRegular
                                id="1"
                                label1="First Name"
                                placeholder="First Name"
                                type='text'
                                onChange={value => this.props.handleUpdateProperty('personalDetails', 'firstName', value)}
                                value={this.props.personalDetails.firstName}
                                required={true}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="First name can't be empty"
                                disabled={this.props.stepVerified}
                            />
                            <InputRegular
                                id="2"
                                label1="Last Name"
                                placeholder="Last Name"
                                type='text'
                                onChange={value => this.props.handleUpdateProperty('personalDetails', 'lastName', value)}
                                value={this.props.personalDetails.lastName}
                                required={true}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="Last name can't be empty"
                                disabled={this.props.stepVerified}
                            />
                            <InputRegular
                                id="3"
                                label1="Email"
                                placeholder="Email"
                                type='email'
                                onChange={value => this.props.handleUpdateProperty('personalDetails', 'email', value)}
                                value={this.props.personalDetails.email}
                                required={true}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="Must enter valid email address"
                                disabled={this.props.stepVerified}
                            />
                            <div
                                className={this.props.stepVerified ? "margin-bottom-10 opacity-05" : "margin-bottom-10"}>
                                <p htmlFor="post-link" className='full-row-label'>Phone</p>
                                <ReactIntlTelInput
                                    className={((this.props.personalDetails.formatedPhone === '') || !this.isPhoneNumber(this.props.personalDetails.formatedPhone)) && this.state.fieldsCheckActive ?
                                        'onboard-tel error' : this.props.personalDetails.formatedPhone === '' ? '' : 'onboard-tel valid'}
                                    inputProps={inputProps}
                                    intlTelOpts={intlTelOpts}
                                    value={this.props.personalDetails.phone}
                                    onChange={(e) => this.handleUpdatePhone(e)}
                                    // onReady={onReady}
                                />
                                {
                                    ((this.props.personalDetails.phone.phone === '') || !this.isPhoneNumber(this.props.personalDetails.phone.phone)) && this.state.fieldsCheckActive ?
                                        <div className="selector-error-label">Valid phone number is required</div>
                                        :
                                        <div className='selector-error-label'></div>
                                }
                            </div>
                        </div>
                        :
                        <div className='inputs-container'>
                            <InputRegular
                                id="1"
                                label1="Business Name"
                                placeholder="Business Name"
                                type='text'
                                onChange={value => this.props.handleUpdateProperty(
                                    window.location.pathname === '/account-verification/business-details' ?
                                        'businessDetails' : 'clientBusinessDetails', 'businessName', value)}
                                value={
                                    window.location.pathname === '/account-verification/business-details' ?
                                        this.props.businessDetails.businessName : this.props.clientBusinessDetails.businessName
                                }
                                required={true}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="Business name can't be empty"
                                disabled={this.props.stepVerified}
                            />
                            <InputRegular
                                id="2"
                                label1="Business Website"
                                placeholder="Business Website"
                                type='url'
                                onChange={value => this.props.handleUpdateProperty(
                                    window.location.pathname === '/account-verification/business-details' ?
                                        'businessDetails' : 'clientBusinessDetails', 'businessWebsite', value)}
                                value={
                                    window.location.pathname === '/account-verification/business-details' ?
                                        this.props.businessDetails.businessWebsite : this.props.clientBusinessDetails.businessWebsite
                                }
                                required={true}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="Enter valid website"
                                disabled={this.props.stepVerified}
                            />
                            <InputRegular
                                id="3"
                                label1="Business Id Number"
                                placeholder="Business Id Number"
                                type='text'
                                onChange={value => this.props.handleUpdateProperty(
                                    window.location.pathname === '/account-verification/business-details' ?
                                        'businessDetails' : 'clientBusinessDetails', 'businessIdNumber', value)}
                                value={
                                    window.location.pathname === '/account-verification/business-details' ?
                                        this.props.businessDetails.businessIdNumber : this.props.clientBusinessDetails.businessIdNumber
                                }
                                required={true}
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="Business Id can't be empty"
                                disabled={this.props.stepVerified}
                            />
                            <InputRegular
                                id="4"
                                label1="Business VAT Number"
                                placeholder="Business VAT Number"
                                type='text'
                                onChange={value => this.props.handleUpdateProperty(
                                    window.location.pathname === '/account-verification/business-details' ?
                                        'businessDetails' : 'clientBusinessDetails', 'businessVatNumber', value)}
                                value={
                                    window.location.pathname === '/account-verification/business-details' ?
                                        this.props.businessDetails.businessVatNumber : this.props.clientBusinessDetails.businessVatNumber
                                }
                                required={false}
                                // fieldsCheckActive={this.state.fieldsCheckActive}
                                // updateErrorsList={this.updateErrorsList}
                                // errorMessage="VAT number can't be empty"
                                disabled={this.props.stepVerified}
                            />
                        </div>
                }
                <h2>Address</h2>
                <div className='inputs-container'>
                    <InputRegular
                        id="5"
                        label1="Address Line 1"
                        placeholder="Address Line 1"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/personal-details' ?
                                'personalDetails'
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    'businessDetails' : 'clientBusinessDetails', 'addressLine1', value)}
                        value={
                            window.location.pathname === '/account-verification/personal-details' ?
                                this.props.personalDetails.addressLine1
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    this.props.businessDetails.addressLine1 : this.props.clientBusinessDetails.addressLine1
                        }
                        required={true}
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="Address can't be empty"
                        disabled={this.props.stepVerified}
                    />
                    <InputRegular
                        id="6"
                        label1="Address Line 2"
                        placeholder="Address Line 2"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/personal-details' ?
                                'personalDetails'
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    'businessDetails' : 'clientBusinessDetails', 'addressLine2', value)}
                        value={
                            window.location.pathname === '/account-verification/personal-details' ?
                                this.props.personalDetails.addressLine2
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    this.props.businessDetails.addressLine2 : this.props.clientBusinessDetails.addressLine2
                        }
                        required={false}
                        // fieldsCheckActive={this.state.fieldsCheckActive}
                        // updateErrorsList={this.updateErrorsList}
                        // errorMessage="Amount can't be less than $20"
                        disabled={this.props.stepVerified}
                    />
                    <InputRegular
                        id="7"
                        label1="City"
                        placeholder="City"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/personal-details' ?
                                'personalDetails'
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    'businessDetails' : 'clientBusinessDetails', 'city', value)}
                        value={
                            window.location.pathname === '/account-verification/personal-details' ?
                                this.props.personalDetails.city
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    this.props.businessDetails.city : this.props.clientBusinessDetails.city
                        }
                        required={true}
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="City must be entered"
                        disabled={this.props.stepVerified}
                    />
                    <InputRegular
                        id="8"
                        label1="State"
                        placeholder="State"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/personal-details' ?
                                'personalDetails'
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    'businessDetails' : 'clientBusinessDetails', 'state', value)}
                        value={
                            window.location.pathname === '/account-verification/personal-details' ?
                                this.props.personalDetails.state
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    this.props.businessDetails.state : this.props.clientBusinessDetails.state
                        }
                        required={false}
                        // fieldsCheckActive={this.state.fieldsCheckActive}
                        // updateErrorsList={this.updateErrorsList}
                        // errorMessage="Amount can't be less than $20"
                        disabled={this.props.stepVerified}
                    />
                    <InputRegular
                        id="7"
                        label1="Zip Code"
                        placeholder="Zip Code"
                        type='text'
                        onChange={value => this.props.handleUpdateProperty(
                            window.location.pathname === '/account-verification/personal-details' ?
                                'personalDetails'
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    'businessDetails' : 'clientBusinessDetails', 'zipCode', value)}
                        value={
                            window.location.pathname === '/account-verification/personal-details' ?
                                this.props.personalDetails.zipCode
                                :
                                window.location.pathname === '/account-verification/business-details' ?
                                    this.props.businessDetails.zipCode : this.props.clientBusinessDetails.zipCode
                        }
                        required={true}
                        fieldsCheckActive={this.state.fieldsCheckActive}
                        updateErrorsList={this.updateErrorsList}
                        errorMessage="Please enter Zip Code"
                        disabled={this.props.stepVerified}
                    />
                    <Select
                        items={this.state.filteredCountries}
                        itemRenderer={(item, index) => <MenuItem
                            key={index}
                            onClick={() => {
                                this.setState({
                                    countryName: item.name,
                                    countryCode: item.code
                                })
                                this.props.handleUpdateProperty(
                                    window.location.pathname === '/account-verification/personal-details' ?
                                        'personalDetails'
                                        :
                                        window.location.pathname === '/account-verification/business-details' ?
                                            'businessDetails' : 'clientBusinessDetails', 'country', item.name)
                            }
                            }
                            text={item.name + ' ' + item.flag}
                        />}
                        filterable={true}
                        onQueryChange={this.filterItems}
                        resetOnClose={true}
                        className={this.props.stepVerified ? 'country-selector opacity-05' : 'country-selector'}
                        disabled={this.props.stepVerified}
                    >
                        <label style={{marginBottom: 5}}>Country</label>
                        <Button
                            className={((window.location.pathname === '/account-verification/personal-details') &&
                                (this.props.personalDetails.country === 'Select Country') ||
                                ((window.location.pathname === '/account-verification/business-details') &&
                                    (this.props.businessDetails.country === 'Select Country')) ||
                                ((window.location.pathname === '/account-verification/client-business-details') &&
                                    (this.props.clientBusinessDetails.country === 'Select Country'))) && this.state.fieldsCheckActive ?
                                'country-selector-error' :
                                ((window.location.pathname === '/account-verification/personal-details') &&
                                    (this.props.personalDetails.country === 'Select Country') ||
                                    ((window.location.pathname === '/account-verification/business-details') &&
                                        (this.props.businessDetails.country === 'Select Country')) ||
                                    ((window.location.pathname === '/account-verification/client-business-details') &&
                                        (this.props.clientBusinessDetails.country === 'Select Country'))) ?
                                    'country-selector-empty' : 'country-selector'}
                            text={window.location.pathname === '/account-verification/personal-details' ?
                                this.props.personalDetails.country : window.location.pathname === '/account-verification/business-details' ?
                                    this.props.businessDetails.country : this.props.clientBusinessDetails.country}
                            rightIcon="caret-down">
                        </Button>

                    </Select>
                </div>
                {
                    window.location.pathname === '/account-verification/personal-details' ||
                    window.location.pathname === '/account-verification/business-details' ?
                        <h2>Upload your business documentation</h2>
                        :
                        ''
                }
                {
                    (window.location.pathname === '/account-verification/personal-details') ||
                    (window.location.pathname === '/account-verification/business-details') ?
                        <div
                            className={this.props.documentationVerified ? 'drag-drop-container opacity-05' : ((window.location.pathname === '/account-verification/personal-details') &&
                                this.props.personalDetails && !this.props.personalDetails.files.length &&
                                this.state.fieldsCheckActive) ||
                            ((window.location.pathname === '/account-verification/business-details') &&
                                this.props.businessDetails && !this.props.businessDetails.files.length &&
                                this.state.fieldsCheckActive) ? 'drag-drop-container error' : 'drag-drop-container'}>
                            {/*<input type="file" id="file" ref="file" onInput={this.onDrop}></input>*/}
                            <FileUpload
                                category={'verification-documents'}
                                maxSizeMb={25}
                                fileType='document'
                                disabled={this.props.documentationVerified}
                                text={'Drag and drop your file here'}
                                buttonText={'Browse files'}
                                buttonType='grey'
                                onUploadStart={this.onFileUploadStart}
                                onUploadEnd={this.onFileUploadEnd}
                                onUploadProgressChange={this.onUploadProgressChange}
                                hideLoader={true}
                                loaderSize={'small'}
                            />

                            <div className='uploader-files-container'>
                                <h2>Uploaded files</h2>
                                {
                                    window.location.pathname === '/account-verification/personal-details' ?
                                        this.props.personalDetails.files.map((file, index) => <div
                                            className='display-flex flex-direction-row space-between'>
                                            <p className='margin-bottom-10'>{file.name}</p>
                                            <p className="modal-close-button"
                                               onClick={this.props.documentationVerified ? '' : () => this.handleDeleteUrl(index)}>
                                                <i
                                                    className="fas fa-times"></i></p>
                                        </div>)
                                        :
                                        this.props.businessDetails.files.map((file, index) => <div
                                            className='display-flex flex-direction-row space-between'>
                                            <p className='margin-bottom-10'>{file.name}</p>
                                            <p className="modal-close-button"
                                               onClick={this.props.documentationVerified ? '' : () => this.handleDeleteUrl(index)}>
                                                <i
                                                    className="fas fa-times"></i></p>
                                        </div>)
                                }
                                {
                                    this.state.fileLoaderActive ?
                                        <ProgressBar intent='primary' value={this.state.loaded} animate={false}
                                                     stripes={false}/>
                                        :
                                        ''
                                }
                            </div>
                        </div>
                        :
                        ''
                }
                {
                    (window.location.pathname === '/account-verification/personal-details') ||
                    (window.location.pathname === '/account-verification/business-details') ?
                        <p className='padding-top-30'>
                            Provide a Bank statement or a Certificate of company incorporation proving you have a valid
                            business.
                            Emitto treats this as sensitive data with maximum confidentiality according to the
                            <a target='_blank' href="https://app.emitto.io/privacy"> Privacy Policy</a> and
                            <a target='_blank' href="https://emitto.io/terms-of-service"> Terms of Service</a>.
                        </p>
                        :
                        ''
                }

                {
                    (window.location.pathname === '/account-verification/personal-details') ?
                        <p className='padding-top-30 terms-checkbox'><input className='checkbox' type="checkbox"
                                                                            checked={this.state.termsChecked}
                                                                            onChange={() => this.setState({termsChecked: !this.state.termsChecked})}/> By
                            Submitting this form, I agree to the
                            <a target='_blank' href="https://emitto.io/terms-of-service"> Terms of Service, </a>
                            <a target='_blank' href="https://app.emitto.io/privacy"> Privacy Policy</a> and
                            <a href='https://emitto.io/know-your-customer-policy' target='_blank'> KYC Policy</a>.
                        </p>
                        :
                        ''
                }
                <div className='bottom-with-buttons space'>
                    {window.location.pathname === '/account-verification/client-business-details' ?
                        <button className="btn-white-border"
                                onClick={() => this.props.history.push('/account-verification/authorized-representative-details')}>Previous</button>
                        :
                        <button className="btn-white-border"
                                onClick={() => this.props.history.push('/account-verification/select-type')}>Previous</button>
                    }
                    {window.location.pathname === '/account-verification/personal-details' ?
                        this.props.spinner ?
                            <button className='btn-action btn-spinner' disabled={true}>Submit <i
                                className='fa fa-spin fa-spinner'></i></button>
                            :
                            <button disabled={!this.state.termsChecked} className='btn-action'
                                    onClick={this.handleSubmit}>Submit</button>
                        :
                        window.location.pathname === '/account-verification/business-details' ?
                            this.props.spinner ?
                                <button className='btn-action btn-spinner' disabled={true}>Next <i
                                    className='fa fa-spin fa-spinner'></i></button>
                                :
                                <button className='btn-action'
                                        onClick={this.props.stepVerified && this.props.documentationVerified ?
                                            () => this.props.history.push('/account-verification/authorized-representative-details') : this.handleSubmit}>Next</button>
                            :
                            this.props.spinner ?
                                <button className='btn-action btn-spinner' disabled={true}>Next <i
                                    className='fa fa-spin fa-spinner'></i></button>
                                :
                                <button className='btn-action' onClick={this.props.stepVerified ?
                                    () => this.props.history.push('/account-verification/client-contact-person-details') : this.handleSubmit}>Next</button>
                    }
                </div>
            </div>
        )
    }
}
